var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-lg font-medium ui-button h-14",class:[
    { small: _vm.small },
    { rounded: _vm.rounded },
    { medium: _vm.medium },
    { outline: _vm.outline },
    { fair: _vm.fair },
    { transparent: _vm.transparent },
    { white: _vm.white },
    {
      'h-9': _vm.small
    },
    {
      'h-11': _vm.medium
    }
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }